import { GetStaticProps } from 'next';
import React from 'react';
import { getStaticPropsHotels } from '@layout/get-page-props';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { ContentApi } from '@model/iceberg';
import { Page, TripTypes } from '@model/common';
import { PageTemplates } from '@model/content';
import { Revalidate } from '@model/config/revalidate';
import { HotelsPageLayout, HotelsPageLayoutProps } from '@layout/HotelsPageLayout/HotelsPageLayout';
import { useI18NextContext } from '@components/hooks';
import { DestinationLevel, getDestinationPagePaths } from '@util/get-destination-static-paths';

const CountryFromPricesPage = (props: HotelsPageLayoutProps) => {
  const { display } = props;
  const t: any = useI18NextContext();
  const metaTitle: string = t('seo__destination-listing-page--title', {
    destination: display
  });
  const metaDescription: string = t('seo__destination-listing-page--description', {
    destination: display
  });

  return <HotelsPageLayout {...props} metaTitle={metaTitle} metaDescription={metaDescription} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async (props: any) => ({
  ...(await getStaticPropsHotels(store, props)),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const destinationPages = await new ContentApi().getPageConfigMap({ template: PageTemplates.DESTINATION });
  const paths = getDestinationPagePaths({
    destinationPages,
    level: DestinationLevel.COUNTRY,
    tripType: TripTypes.HOLIDAYS,
    suffix: Page.HOTELS
  });

  return { paths, fallback: false };
}

export default withGlobalProvider(CountryFromPricesPage);
